import { Button, Card, Flex, Link, Text } from '@workwhile/ui'
import { YardstickReport } from 'api/typings'
import { RefreshCcw } from 'lucide-react'
import React, { useState } from 'react'

type PremiumPlusFederalCardProps = {
  premiumPlusFederal: YardstickReport
  sequence: number
  makeReportUrl: (reportId: string) => string | undefined
  refreshReport: (reportId: string) => Promise<void>
}

const PremiumPlusFederalCard = ({
  premiumPlusFederal,
  sequence,
  makeReportUrl,
  refreshReport,
}: PremiumPlusFederalCardProps) => {
  const [refreshFetching, setRefreshFetching] = useState(false)

  const reportUrl =
    premiumPlusFederal.reportId && premiumPlusFederal.reportId.trim()
      ? makeReportUrl(premiumPlusFederal.reportId)
      : undefined

  const refreshVisible = Boolean(
    premiumPlusFederal.reportId && premiumPlusFederal.reportId.trim()
  )

  const handleClickRefresh = async () => {
    if (!premiumPlusFederal.reportId || !premiumPlusFederal.reportId.trim()) {
      return
    }

    setRefreshFetching(true)
    try {
      await refreshReport(premiumPlusFederal.reportId)
    } catch (error) {
      console.error('ERROR OCCURED REFRESHING PREMIUM FEDERAL STATUS: ', error)
    }

    setRefreshFetching(false)
  }

  return (
    <Card shadowless mb={2}>
      <Flex justifyContent="space-between">
        <Text>
          Premium + Federal #{sequence}{' '}
          {reportUrl ? (
            <Link
              to={reportUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginLeft: '0.5rem' }}
              color="primary"
            >
              (View report)
            </Link>
          ) : null}
        </Text>
        {refreshVisible ? (
          <Button
            kind="small"
            onClick={handleClickRefresh}
            style={{ padding: 4 }}
            variant="text"
            disabled={refreshFetching}
          >
            <RefreshCcw size={14} />
          </Button>
        ) : null}
      </Flex>
      <Flex align="center">
        <Text fontSize={3} style={{ textTransform: 'capitalize' }} mt={1}>
          {premiumPlusFederal.status}
        </Text>
      </Flex>
    </Card>
  )
}

type UserPremiumPlusFederalProps = {
  premiumPlusFederalReports?: YardstickReport[]
  makeReportUrl: (reportId: string) => string | undefined
  refreshReport: (reportId: string) => Promise<void>
}

export const UserPremiumPlusFederal = ({
  premiumPlusFederalReports,
  makeReportUrl,
  refreshReport,
}: UserPremiumPlusFederalProps) => {
  if (!premiumPlusFederalReports || premiumPlusFederalReports.length === 0) {
    return (
      <>
        <Text mb={2}>Premium + Federal</Text>
        <Text>No premium federal verification found for this user</Text>
      </>
    )
  }

  return (
    <>
      <Text mb={2}>Premium + Federal</Text>
      {premiumPlusFederalReports.map((premiumPlusFederal, index) => (
        <PremiumPlusFederalCard
          key={premiumPlusFederal.reportId}
          premiumPlusFederal={premiumPlusFederal}
          sequence={index + 1}
          makeReportUrl={makeReportUrl}
          refreshReport={refreshReport}
        />
      ))}
    </>
  )
}
